<template>
  <div id="patientPaymentsView">
    <AppBar />

    <div class="area">
      <VerificationPendingBanner />

      <div class="area-head">
        <div>
          <h1 class="greet" style="font-size:var(--font-size-3xl)">
            Meus pagamentos
          </h1>
          <p class="sub">
            Histórico de pagamentos vinculados às suas consultas.
          </p>
        </div>
        <!-- <router-link
          :to="{ path: '/', query: { buscar: '1' } }"
          class="btn btn--accent btn--lg"
        >
          Agendar consulta
        </router-link> -->
      </div>

      <div class="tabs">
        <span
          v-for="tab in tabs"
          :key="tab.key"
          class="tab"
          :class="{ 'tab--active': activeTab === tab.key }"
          style="cursor:pointer"
          @click="activeTab = tab.key"
        >
          {{ tab.label }} · {{ tab.count }}
        </span>
      </div>

      <!-- PENDENTES -->
      <div v-show="activeTab === 'pendentes'">
        <div v-if="loading" class="state-box"><p>Carregando...</p></div>
        <div v-else-if="pendingPayments.length" class="appt-list">
          <div
            v-for="item in pendingPayments"
            :key="item.id"
            class="card appt-row"
          >
            <div class="when">
              <div class="d">{{ formatDay(item.scheduled_at) }}</div>
              <div class="h">{{ formatTime(item.scheduled_at) }}</div>
            </div>
            <div class="appt-info">
              <div class="row" style="gap:var(--space-3)">
                <div class="avatar avatar--sm">
                  <img
                    v-if="item.doctor_photo"
                    :src="item.doctor_photo"
                    :alt="item.doctor_name"
                    loading="lazy"
                    decoding="async"
                  />
                  <template v-else>{{ doctorInitials(item) }}</template>
                </div>
                <span class="nm">{{ item.doctor_name }}</span>
                <span class="badge badge--warning">Pendente</span>
              </div>
              <span class="meta">
                {{ item.doctor_specialty }} ·
                {{ item.order && item.order.formatted_final_price }}
              </span>
            </div>
            <div class="appt-acts" @click.stop>
              <b-dropdown
                text="Forma de pagamento"
                toggle-class="btn--accent btn--sm pay-toggle"
                no-caret
                right
              >
                <b-dropdown-item @click="openPixModal(item)">
                  Pix
                </b-dropdown-item>
                <b-dropdown-item @click="openCreditCardModal(item)">
                  Cartão de crédito
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
        <div v-else class="state-box">
          <div class="ill">
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
              <circle
                cx="12"
                cy="12"
                r="9"
                stroke="currentColor"
                stroke-width="2"
              />
              <path
                d="M12 8v4l3 3"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <h3>Nenhum pagamento pendente</h3>
          <p>Consultas com pagamento em aberto aparecerão aqui.</p>
        </div>
        <list-pagination
          v-if="!loading && pendingPayments.length"
          :page="pages.pendentes"
          :total="totals.pendentes"
          label="pagamentos"
          @change="goToPage('pendentes', $event)"
        />
      </div>

      <!-- PAGOS -->
      <div v-show="activeTab === 'pagos'">
        <div v-if="loading" class="state-box"><p>Carregando...</p></div>
        <div v-else-if="paidPayments.length" class="appt-list">
          <div
            v-for="item in paidPayments"
            :key="item.id"
            class="card appt-row"
            style="cursor:pointer"
            @click="openReceiptModal(item)"
          >
            <div class="when">
              <div class="d">{{ formatDay(item.scheduled_at) }}</div>
              <div class="h">{{ formatTime(item.scheduled_at) }}</div>
            </div>
            <div class="appt-info">
              <div class="row" style="gap:var(--space-3)">
                <div class="avatar avatar--sm">
                  <img
                    v-if="item.doctor_photo"
                    :src="item.doctor_photo"
                    :alt="item.doctor_name"
                    loading="lazy"
                    decoding="async"
                  />
                  <template v-else>{{ doctorInitials(item) }}</template>
                </div>
                <span class="nm">{{ item.doctor_name }}</span>
                <span class="badge badge--success">Pago</span>
              </div>
              <span class="meta">
                {{ item.doctor_specialty }} ·
                {{ item.order && item.order.formatted_final_price }}
              </span>
            </div>
            <div class="appt-acts">
              <button class="btn btn--outline btn--sm">Ver comprovante</button>
            </div>
          </div>
        </div>
        <div v-else class="state-box">
          <div class="ill">
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
              <circle
                cx="12"
                cy="12"
                r="9"
                stroke="currentColor"
                stroke-width="2"
              />
              <path
                d="M9 12l2 2 4-4"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h3>Nenhum pagamento realizado</h3>
          <p>Consultas pagas aparecerão aqui com o comprovante.</p>
        </div>
        <list-pagination
          v-if="!loading && paidPayments.length"
          :page="pages.pagos"
          :total="totals.pagos"
          label="pagamentos"
          @change="goToPage('pagos', $event)"
        />
      </div>

      <!-- EXPIRADOS -->
      <div v-show="activeTab === 'expirados'">
        <div v-if="loading" class="state-box"><p>Carregando...</p></div>
        <div v-else-if="expiredPayments.length" class="appt-list">
          <div
            v-for="item in expiredPayments"
            :key="item.id"
            class="card appt-row is-cancel"
            style="cursor:pointer"
            @click="openExpiredModal(item)"
          >
            <div class="when">
              <div class="d">{{ formatDay(item.scheduled_at) }}</div>
              <div class="h">{{ formatTime(item.scheduled_at) }}</div>
            </div>
            <div class="appt-info">
              <div class="row" style="gap:var(--space-3)">
                <div class="avatar avatar--sm">
                  <img
                    v-if="item.doctor_photo"
                    :src="item.doctor_photo"
                    :alt="item.doctor_name"
                    loading="lazy"
                    decoding="async"
                  />
                  <template v-else>{{ doctorInitials(item) }}</template>
                </div>
                <span class="nm">{{ item.doctor_name }}</span>
                <span class="badge badge--danger">Expirado</span>
              </div>
              <span class="meta">
                {{ item.doctor_specialty }} ·
                {{ item.order && item.order.formatted_final_price }}
              </span>
            </div>
            <div class="appt-acts">
              <button class="btn btn--ghost btn--sm">Ver detalhes</button>
            </div>
          </div>
        </div>
        <div v-else class="state-box">
          <div class="ill">
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <h3>Nenhum Pix expirado</h3>
          <p>Pagamentos com prazo encerrado aparecerão aqui.</p>
        </div>
        <list-pagination
          v-if="!loading && expiredPayments.length"
          :page="pages.expirados"
          :total="totals.expirados"
          label="pagamentos"
          @change="goToPage('expirados', $event)"
        />
      </div>

      <!-- ESTORNADOS -->
      <div v-show="activeTab === 'estornados'">
        <div v-if="loading" class="state-box"><p>Carregando...</p></div>
        <div v-else-if="refundedPayments.length" class="appt-list">
          <div
            v-for="item in refundedPayments"
            :key="item.id"
            class="card appt-row is-cancel"
          >
            <div class="when">
              <div class="d">{{ formatDay(item.scheduled_at) }}</div>
              <div class="h">{{ formatTime(item.scheduled_at) }}</div>
            </div>
            <div class="appt-info">
              <div class="row" style="gap:var(--space-3)">
                <div class="avatar avatar--sm">
                  <img
                    v-if="item.doctor_photo"
                    :src="item.doctor_photo"
                    :alt="item.doctor_name"
                    loading="lazy"
                    decoding="async"
                  />
                  <template v-else>{{ doctorInitials(item) }}</template>
                </div>
                <span class="nm">{{ item.doctor_name }}</span>
                <span class="badge badge--danger">Estornado</span>
              </div>
              <span class="meta">
                {{ item.doctor_specialty }} ·
                {{ item.order && item.order.formatted_final_price }}
              </span>
            </div>
          </div>
        </div>
        <div v-else class="state-box">
          <div class="ill">
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
              <path
                d="M3 12a9 9 0 1 0 3-6.7M3 4v4h4"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <h3>Nenhum pagamento estornado</h3>
          <p>Consultas com pagamento estornado aparecerão aqui.</p>
        </div>
        <list-pagination
          v-if="!loading && refundedPayments.length"
          :page="pages.estornados"
          :total="totals.estornados"
          label="pagamentos"
          @change="goToPage('estornados', $event)"
        />
      </div>
    </div>

    <footer class="foot-mini">
      <router-link to="/" class="vm-mark">
        <img
          class="vm-logo"
          src="../assets/images/logo-videomedi.png"
          alt="Videomedi"
        />
      </router-link>
      <span class="cpy">© 2026 Videomedi · CNPJ 00.000.000/0001-00</span>
      <div class="links">
        <a href="#">Privacidade</a>
        <a href="#">Termos de Uso</a>
        <a href="#">LGPD</a>
        <a href="#">Suporte</a>
      </div>
    </footer>

    <!-- Modal Pix pendente -->
    <b-modal
      v-if="selectedItem"
      id="modal-pix"
      hide-header
      hide-footer
      centered
      @hidden="selectedItem = null"
    >
      <Pix
        :pix-data="selectedItem.order && selectedItem.order.pix_data"
        context="modal"
        @close="$bvModal.hide('modal-pix')"
      />
    </b-modal>

    <!-- Modal Cartão de crédito -->
    <b-modal
      v-if="selectedItem"
      id="modal-credit-card"
      title="Pagar com cartão de crédito"
      hide-footer
      centered
      @hidden="
        selectedItem = null;
        selectedCreditCard = null;
        payError = null;
      "
    >
      <div v-if="loadingCards" class="state-box">
        <p>Carregando cartões...</p>
      </div>
      <div v-else-if="!creditCards.length" class="state-box">
        <p>
          Nenhum cartão cadastrado. Adicione um cartão em
          <router-link to="/profile">Minha conta</router-link>
          .
        </p>
      </div>
      <div v-else>
        <div
          v-for="card in creditCards"
          :key="card.id"
          class="card-option"
          :class="{
            'card-option--selected':
              selectedCreditCard && selectedCreditCard.id === card.id
          }"
          @click="selectedCreditCard = card"
        >
          <span class="card-option-brand">
            {{ card.brand }} ····{{ card.last_four }}
          </span>
          <span v-if="card.nickname" class="card-option-nick">
            {{ card.nickname }}
          </span>
        </div>
        <p v-if="payError" class="pay-error">{{ payError }}</p>
        <div class="receipt-actions" style="margin-top:var(--space-5)">
          <button
            class="btn btn--accent btn--sm"
            :disabled="!selectedCreditCard || loadingCardPay"
            @click="payWithCreditCard"
          >
            {{ loadingCardPay ? "Processando…" : "Confirmar pagamento" }}
          </button>
          <button
            class="btn btn--ghost btn--sm"
            @click="$bvModal.hide('modal-credit-card')"
          >
            Fechar
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Modal comprovante -->
    <b-modal
      v-if="selectedItem"
      id="modal-receipt"
      title="Comprovante de pagamento"
      hide-footer
      centered
      @hidden="selectedItem = null"
    >
      <div ref="receiptContent" class="receipt">
        <div class="receipt-row">
          <span class="receipt-label">Profissional de saúde</span>
          <span class="receipt-value">{{ selectedItem.doctor_name }}</span>
        </div>
        <div class="receipt-row">
          <span class="receipt-label">Especialidade</span>
          <span class="receipt-value">{{ selectedItem.doctor_specialty }}</span>
        </div>
        <div class="receipt-row">
          <span class="receipt-label">Data da consulta</span>
          <span class="receipt-value">
            {{ formatDateTime(selectedItem.scheduled_at) }}
          </span>
        </div>
        <div class="receipt-row">
          <span class="receipt-label">Valor</span>
          <span class="receipt-value">
            {{ selectedItem.order && selectedItem.order.formatted_final_price }}
          </span>
        </div>
        <div class="receipt-row">
          <span class="receipt-label">Data do pagamento</span>
          <span class="receipt-value">
            {{
              formatDateTime(selectedItem.order && selectedItem.order.paid_at)
            }}
          </span>
        </div>
        <div class="receipt-row">
          <span class="receipt-label">Forma de pagamento</span>
          <span class="receipt-value">{{ paymentMethod(selectedItem) }}</span>
        </div>
      </div>
      <div class="receipt-actions">
        <button class="btn btn--outline btn--sm" @click="downloadReceipt()">
          Baixar PDF
        </button>
        <button
          class="btn btn--ghost btn--sm"
          @click="$bvModal.hide('modal-receipt')"
        >
          Fechar
        </button>
      </div>
    </b-modal>

    <!-- Modal expirado -->
    <b-modal
      v-if="selectedItem"
      id="modal-expired"
      title="Pix expirado"
      hide-footer
      centered
      @hidden="selectedItem = null"
    >
      <p class="expired-msg">
        O prazo para pagamento via Pix desta consulta encerrou. Você pode
        reagendar a consulta com o mesmo profissional de saúde ou entrar em
        contato com o suporte caso precise de ajuda.
      </p>
      <div class="receipt-actions">
        <button class="btn btn--accent btn--sm" @click="reschedule()">
          Reagendar
        </button>
        <!-- <a href="#" class="btn btn--outline btn--sm">
          Entrar em contato
        </a> -->
        <button
          class="btn btn--ghost btn--sm"
          @click="$bvModal.hide('modal-expired')"
        >
          Fechar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { format, parseISO } from "date-fns";
import { pt as ptLocale } from "date-fns/locale";
import AppBar from "../components/AppBar.vue";
import VerificationPendingBanner from "../components/VerificationPendingBanner.vue";
import Pix from "../components/Pix.vue";
import ListPagination from "../components/ListPagination.vue";
import { PatientPayments } from "../services/patient_payments";
import { Appointments } from "../services/appointments";
import { CreditCard } from "../services/credit_card";

// Aba da tela → status do pedido no back (GET /appointments/payments?status=).
const TAB_STATUSES = {
  pendentes: "pending",
  pagos: "paid",
  expirados: "expired",
  estornados: "refunded"
};

export default {
  name: "PatientPaymentsView",
  components: { AppBar, VerificationPendingBanner, Pix, ListPagination },

  data() {
    return {
      activeTab: "pendentes",
      loading: false,
      loadingPix: false,
      loadingCards: false,
      loadingCardPay: false,
      // Cada aba é uma lista paginada no back (10 por página), filtrada pelo
      // status; o total vem no header Total-Count.
      paymentsByTab: {
        pendentes: [],
        pagos: [],
        expirados: [],
        estornados: []
      },
      pages: { pendentes: 1, pagos: 1, expirados: 1, estornados: 1 },
      totals: { pendentes: 0, pagos: 0, expirados: 0, estornados: 0 },
      selectedItem: null,
      creditCards: [],
      selectedCreditCard: null,
      payError: null
    };
  },

  async mounted() {
    document.body.className = "";
    document.body.classList.add("Base");
    this.loading = true;
    await Promise.all(Object.keys(TAB_STATUSES).map(this.fetchTab));
    this.loading = false;
  },

  methods: {
    async fetchTab(tab) {
      try {
        const { data, headers } = await PatientPayments.fetch({
          status: TAB_STATUSES[tab],
          page: this.pages[tab]
        });
        // Página que ficou vazia (ex.: pagou o último pendente dela) volta uma.
        if (this.pages[tab] > 1 && !data.length) {
          this.pages[tab] -= 1;
          return this.fetchTab(tab);
        }
        this.paymentsByTab[tab] = data;
        this.totals[tab] = Number(headers?.["total-count"]) || 0;
      } catch {
        this.paymentsByTab[tab] = [];
        this.totals[tab] = 0;
      }
    },
    goToPage(tab, page) {
      this.pages[tab] = page;
      return this.fetchTab(tab);
    },
    formatDay(iso) {
      if (!iso) return "";
      return format(parseISO(iso), "EEE · d MMM yyyy", { locale: ptLocale });
    },
    formatTime(iso) {
      if (!iso) return "";
      return format(parseISO(iso), "HH:mm");
    },
    formatDateTime(iso) {
      if (!iso) return "—";
      return format(parseISO(iso), "dd/MM/yyyy 'às' HH:mm", {
        locale: ptLocale
      });
    },
    doctorInitials(item) {
      return (
        (item.doctor_name || "")
          .split(" ")
          .slice(0, 2)
          .map(n => n[0])
          .join("")
          .toUpperCase() || "?"
      );
    },
    paymentMethod(item) {
      const order = item.order;
      if (!order) return "Não disponível";

      const creditCard = order.payment?.credit_card;
      if (creditCard)
        return `Cartão ${creditCard.brand} ····${creditCard.last_four}`;
      if (order.pix_data) return "Pix";
      return "Não disponível";
    },
    async openPixModal(item) {
      this.loadingPix = true;
      this.selectedItem = item;
      try {
        const { data } = await Appointments.pendingPayment(item.id);
        this.selectedItem = {
          ...item,
          order: { ...item.order, pix_data: data.order.pix_data }
        };
      } catch {
        // usa pix_data da listagem como fallback
      } finally {
        this.loadingPix = false;
      }
      this.$nextTick(() => this.$bvModal.show("modal-pix"));
    },
    async openCreditCardModal(item) {
      this.selectedItem = item;
      this.selectedCreditCard = null;
      this.payError = null;
      this.loadingCards = true;
      try {
        const { data } = await CreditCard.fetch();
        this.creditCards = data;
      } catch {
        this.creditCards = [];
      } finally {
        this.loadingCards = false;
      }
      this.$nextTick(() => this.$bvModal.show("modal-credit-card"));
    },
    async payWithCreditCard() {
      if (!this.selectedCreditCard) return;
      this.loadingCardPay = true;
      this.payError = null;
      try {
        await Appointments.payWithCreditCard(
          this.selectedItem.id,
          this.selectedCreditCard.id
        );
        this.$bvModal.hide("modal-credit-card");
        await Promise.all([this.fetchTab("pendentes"), this.fetchTab("pagos")]);
      } catch (e) {
        this.payError =
          (e.response &&
            e.response.data &&
            e.response.data.errors &&
            e.response.data.errors.details) ||
          "Erro ao processar pagamento. Tente novamente.";
      } finally {
        this.loadingCardPay = false;
      }
    },
    downloadReceipt() {
      const element = this.$refs.receiptContent;
      const doctorSlug = (this.selectedItem.doctor_name || "comprovante")
        .toLowerCase()
        .replace(/\s+/g, "-");
      const date = this.selectedItem.scheduled_at
        ? format(parseISO(this.selectedItem.scheduled_at), "yyyy-MM-dd")
        : "sem-data";

      const scale = 3;
      html2canvas(element, { scale }).then(canvas => {
        const pdf = new jsPDF({
          unit: "mm",
          format: "a4",
          orientation: "portrait"
        });
        const imgData = canvas.toDataURL("image/jpeg", 0.98);
        const pxToMm = 25.4 / 96;
        const pageWidth = pdf.internal.pageSize.getWidth();
        const imgWidth = Math.min((canvas.width / scale) * pxToMm, 190);
        const imgHeight = (canvas.height / scale) * pxToMm;
        const x = (pageWidth - imgWidth) / 2;
        pdf.addImage(imgData, "JPEG", x, 10, imgWidth, imgHeight);
        pdf.save(`comprovante-${doctorSlug}-${date}.pdf`);
      });
    },
    openReceiptModal(item) {
      this.selectedItem = item;
      this.$nextTick(() => this.$bvModal.show("modal-receipt"));
    },
    openExpiredModal(item) {
      this.selectedItem = item;
      this.$nextTick(() => this.$bvModal.show("modal-expired"));
    },
    reschedule() {
      const doctorId = this.selectedItem.doctor_id;
      this.$bvModal.hide("modal-expired");
      this.$router.push({
        name: "SchedulePayment",
        params: { doctor: doctorId }
      });
    }
  },

  computed: {
    pendingPayments() {
      return this.paymentsByTab.pendentes;
    },
    paidPayments() {
      return this.paymentsByTab.pagos;
    },
    expiredPayments() {
      return this.paymentsByTab.expirados;
    },
    refundedPayments() {
      return this.paymentsByTab.estornados;
    },
    tabs() {
      return [
        {
          key: "pendentes",
          label: "Pendentes",
          count: this.totals.pendentes
        },
        { key: "pagos", label: "Pagos", count: this.totals.pagos },
        {
          key: "expirados",
          label: "Expirados",
          count: this.totals.expirados
        },
        {
          key: "estornados",
          label: "Estornados",
          count: this.totals.estornados
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.vm-logo {
  display: block;
  height: 22px;
  width: auto;
}

#patientPaymentsView {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--color-bg-page);
}

.receipt {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin-bottom: var(--space-5);
}

.receipt-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: var(--space-3);
  font-size: 0.9rem;
  border-bottom: 1px solid var(--color-border, #e9ecef);
  padding-bottom: var(--space-2);
}

.receipt-label {
  color: var(--color-text-muted, #6c757d);
  flex-shrink: 0;
}

.receipt-value {
  font-weight: 500;
  text-align: right;
}

.receipt-actions {
  display: flex;
  gap: var(--space-3);
  justify-content: flex-end;
}

.expired-msg {
  color: var(--color-text-muted, #6c757d);
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: var(--space-5);
}

.card-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--color-border, #e9ecef);
  border-radius: var(--radius-md, 8px);
  margin-bottom: var(--space-2);
  cursor: pointer;
  transition: border-color 0.15s;

  &:hover {
    border-color: var(--color-accent, #d81a67);
  }

  &--selected {
    border-color: var(--color-accent, #d81a67);
    background: rgba(216, 26, 103, 0.04);
  }
}

.card-option-brand {
  font-size: 0.9rem;
  font-weight: 500;
}

.card-option-nick {
  font-size: 0.8rem;
  color: var(--color-text-muted, #6c757d);
}

.pay-error {
  color: var(--color-danger, #dc3545);
  font-size: 0.85rem;
  margin-top: var(--space-3);
}

::v-deep .pay-toggle {
  &,
  &:hover,
  &:focus,
  &:active,
  &.active {
    background: var(--color-accent) !important;
    color: #fff !important;
    border-color: var(--color-accent) !important;
    text-decoration: none !important;
    box-shadow: none !important;
  }
}
</style>
